let config = {
  s3: {
    REGION: "eu-west-1",
    BUCKET: "forwood-eurecovery-testing-forwoodid",
    BATCH_PROCESS_BUCKET_NAME: "forwood-eurecovery-testing-forwoodid-batch-user-process",
  },
  appSyncAPI: {
    REGION: "eu-west-1",
    URL: "https://jmdttvfsrfettfslac5oi3rjym.appsync-api.eu-west-1.amazonaws.com/graphql",
  },
  apiGateway: {
    REGION: "eu-west-1",
    URL: "https://44drc2p07f.execute-api.eu-west-1.amazonaws.com/env",
    USER_TOKEN_URL: "https://c3e8ob0i8f.execute-api.eu-west-1.amazonaws.com/prod",
  },
  configurationService: {
    URL: "https://config.testing.eurecovery.forwoodsafety.com",
    WEBSOCKET: "wss://mx3s7li7i2.execute-api.eu-west-1.amazonaws.com/testing",
  },
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_0hNtHoTU1",
    IDENTITY_POOL_ID: "eu-west-1:909888ab-5fbf-4164-a1d9-b967f626e60e",
    USERPOOL_HOSTED_DOMAIN: "forwood-eurecovery-id-testing",
    USERPOOL_ADFS_CALLBACK_URL: "https://id.testing.eurecovery.forwoodsafety.com",
    USERPOOL_ADFS_LOGOUT_URL: "https://id.testing.eurecovery.forwoodsafety.com",
    AUTHENTICATED_ROLE_ARN: "arn:aws:iam::732203471533:role/testing-CA",
  },
  samlProvider: {
    NAME: "ForwoodAzure",
    SUPPORTED_LIST: "ForwoodAzure",
  },
  reactApp: {
    VERSION: "1.42.4",
    HOSTNAME: "id.testing.eurecovery.forwoodsafety.com",
    ENV_NAME: "testing",
    COOKIE_DOMAIN: ".testing.eurecovery.forwoodsafety.com",
    SECURE_PROTOCOL: true,
    FORWOOD_COMPANY_ID: "a542ae2b-6931-4307-8ad6-ae03c182c6ca",
    FORWOOD_HOMEPAGE_MICROFRONTEND_URL: "https://homepage.testing.eurecovery.forwoodsafety.com",
  },
  USERPOOL_ADFS_LAUNCH_URL(clientId) {
    return 'https://'+this.cognito.USERPOOL_HOSTED_DOMAIN+'.auth.'+this.cognito.REGION+'.amazoncognito.com/authorize?redirect_uri='+this.cognito.USERPOOL_ADFS_CALLBACK_URL+'&response_type=code&client_id='+clientId;
  },
};

export default config;
